import { useQuery } from "@tanstack/react-query";
import { getOrders } from "../api/Api";
import Progress from './Progress';
import Chef from '../page/Chef';
import * as React from 'react';




export default function OrderLoader() {
  const { data, isLoading, error } = useQuery({
    queryKey: ["menu"],
    queryFn: getOrders,
     refetchInterval: 4000, 
    refetchIntervalInBackground: true,
  });

  const [orders, setOrders] = React.useState([]);

  React.useEffect(() => {
    if (data?.orders) {
      setOrders(data.orders);
    }
  }, [data]);

  if (isLoading) return <Progress />;
  if (error) return <p>Error: {error.message}</p>;

  return <Chef orders={orders} setOrders={setOrders} />;
}

